import "../scss/private.scss";
import { eventQBus } from "./utils/EventQBus";
import registerCompare from "./tiles/Compare";
import registerLazyTile from "./tiles/LazyTile";
import { registerTileNameMaxHeightFix } from "./tiles/TileNameMaxHeightFix";
import registerTooltipInitializer from "./tiles/TooltipInitializer";
import registerDiscountBenefit from "./tiles/DiscountBenefit";
import registerSimilarProductButton from "./tiles/SimilarProductsButton";
import { registerRatingsSheet } from "./ratings-sheet/RatingsSheet";
import { registerColorChange } from "./tiles/ColorChange";
import { registerSponsoredDealSheet } from "./tiles/SponsoredDealSheet";

/*                              */
registerLazyTile();
registerTileNameMaxHeightFix();

eventQBus.on("assets.events.documentReady", () => {
  registerColorChange();
  registerCompare();
  registerTooltipInitializer();
  registerSimilarProductButton();
  registerDiscountBenefit();
  registerRatingsSheet();
  registerSponsoredDealSheet();
});
